module.exports = __webpack_public_path__ + "8cc07f1467d4a50f3daf1ba31680b549.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-98.png
// module id = 156
// module chunks = 0